function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.582 0C10.5218 0 0.75 9.75 0.75 21.6653V216.665C0.75 228.581 10.5259 238.331 22.582 238.331H44.4139V259.996L71.707 238.331L99 259.996V238.331H175.418C187.482 238.331 197.25 228.581 197.25 216.665V205.831C197.25 217.746 187.478 227.496 175.418 227.496H99V205.831H44.418V227.496H28.043C18.9999 227.496 11.668 219.911 11.668 211.246C11.668 201.496 18.9999 194.996 28.043 194.996H175.418C187.482 194.996 197.25 185.246 197.25 173.331V21.6653C197.25 9.75 187.478 0 175.418 0H22.5861L22.582 0Z",
  fill: "white"
});

var SvgTuto = function SvgTuto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 260,
    viewBox: "0 0 198 260",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTuto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tuto.33b0e8b7.svg";
export { ForwardRef as ReactComponent };